import { render, staticRenderFns } from "./r-table.vue?vue&type=template&id=058472f8&"
import script from "./r-table.vue?vue&type=script&lang=js&"
export * from "./r-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports